import React from "react";
import "./InfoGroup.css";

const InfoGroup = ({
  title,
  items,
}: {
  title: string;
  items: { label: string; value?: string }[];
}) => (
  <div>
    <header className="info-group-header">
      <h3>{title}</h3>
    </header>
    <div className="info-tags">
      {items.map((item, i) => (
        <span key={i} className="info-tag">
          {item.label}: {item.value || "-"}
        </span>
      ))}
    </div>
  </div>
);

export default InfoGroup;
